import { faImage } from "@fortawesome/free-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { useState } from "react";
import { useForm } from "react-hook-form";
import Resizer from "react-image-file-resizer";
import { EditmarketCategoryAPI } from "../../../../Api/PanelAdminServices";
import { errorToast, succToast } from "../../../../Utils/Toast/Toast";
import Style from "./EditFirstLevelCategory.module.scss";

const EditFirstLevelCategory = ({
  info,
  setModalEditShow,
  getMarketCategory,
}) => {
  const [photo, setPhoto] = useState("");
  const [disable, setDisable] = useState(false);
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();
  //////آپلود کردن عکس
  const UploadPhoto = async (image) => {
    return await resizeFileLogo(image);
  };
  /////ریسایز کردن logo برای آپلود
  const resizeFileLogo = (file) =>
    new Promise((resolve) => {
      Resizer.imageFileResizer(
        file,
        1024,
        1024,
        "WEBP",
        100,
        0,
        (uri) => {
          setPhoto(uri);
        },
        "base64"
      );
    });
  const onsubmit = (data) => {
    setDisable(true);
    let sendInfo = {
      id: info.key,
      parent: "2",
      category_english: data.english,
      category_persian: data.persian,
      category_fee: "",
      photo: photo ? photo : "",
    };
    EditmarketCategoryAPI(sendInfo, (res) => {
      if (res.status === 1) {
        succToast("با موفقیت ویرایش شد");
        setDisable(false);
        setModalEditShow(false);
      } else {
        errorToast("مشکلی پیش آمده");
        setDisable(false);
      }
    });
    getMarketCategory();
  };
  return (
    <form onSubmit={handleSubmit(onsubmit)} className={Style.levelOne}>
      <section className={Style.logoPart}>
        <div className={Style.uploadImage}>
          <img
            src={
              photo ? photo : `http://cdn.barest.ir/category/${info.key}.jpg`
            }
            alt=""
          />
        </div>
        <input
          id={"uploadPhoto"}
          type="file"
          style={{ display: "none" }}
          onChange={(e) => UploadPhoto(e.target.files[0])}
        />
        <div className={Style.loadImagPart}>
          <label htmlFor={"uploadPhoto"} className={Style.iconHolder}>
            <FontAwesomeIcon className={Style.icon} icon={faImage} />
          </label>
          <h3 className={Style.textLogo}>بارگذاری تصویر</h3>
        </div>
      </section>
      <input
        {...register("persian", { required: true })}
        className={errors.persian ? Style.inputError : Style.inputPart}
        placeholder="نام دسته بندی به فارسی"
        defaultValue={info.namePersian}
      />
      <input
        {...register("english", { required: true })}
        className={errors.english ? Style.inputError : Style.inputPart}
        placeholder="نام دسته بندی به انگلیسی"
        defaultValue={info.nameEnglish}
      />
      <div className={Style.btnHolder}>
        <button type="submit" className={Style.addBtn} disabled={disable}>
          ویرایش
        </button>
      </div>
    </form>
  );
};

export default EditFirstLevelCategory;
